<template>
  <transition name="modal">
    <div v-if="show">
      <div :class="{'modal-mask': show_modal_mask}">
        <div class="modal-wrapper">
          <div class="modal-container"
               :class="{'modal_from_bottom':modal_from_bottom}"
               v-on-clickaway="clickAway">
            <div class="modal-header">
              <div class="font-large close-cross" @click="removeModal"><span class="icon-cross2 pointer"></span></div>
              <slot name="header">default header</slot>
            </div>
            <div class="modal-body">
              <slot name="body">default body</slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="bttn bttn_simple right marg-10">
                  Ok

                </button>
                <button class="bttn bttn_simple right marg-10">
                  Gem

                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import {mixin as clickaway} from 'vue-clickaway'
  export default {
    mixins: [clickaway],
    props: {
      show: {
        type: Boolean,
        default: false
      },
      // if true add @click.stop on open button in parent
      close_on_click_away: {
        type: Boolean,
        default: false
      },
      modal_from_bottom: {
        type: Boolean,
        default: false
      },
      show_modal_mask: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      show () {
        // add overflow hidden on show
        const body = document.querySelector('body')
        this.show === true ? body.classList.add('no-scroll') : this.removeModal()
      }
    },
    methods: {
      setShowModal: function () {
        this.show = true
      },
      removeModal: function () {
        const body = document.querySelector('body')
        this.show = false
        this.$emit('close')
        body.classList.remove('no-scroll')
      },
      clickAway () {
        this.close_on_click_away ? this.removeModal() : null
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    position: relative;
  }

  @media handheld, only screen and (max-width: 767px) {
    .modal-header {
      font-size: 0.7em;
    }

    .modal-wrapper {
      width: 100%;
      height: 100%;
    }

    .close-cross {
      top: 12px;
      left: 12px;
    }
  }

  .modal-container {
    transition: all .3s ease;
    height: 100%;
    width: 100%;
    background-color: #fff;
    color: #4e5665;
    box-shadow: -1px 1px 5px 0px rgba(50, 50, 50, 0.2);
    position: relative;
  }

  @media handheld, only screen and (min-width: 767px) {
    .modal-container {
      height: 580px;
      width: 800px;
      border-radius: 3px;
    }

    .close-cross {
      top: 17px;
      left: 17px;
    }
  }

  .modal-header {
    background: #f6f7f8;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    color: #3d4340;
    border-bottom: 1px solid #d8d8d8;
    text-align: center;
    position: relative;
  }

  .close-cross {
    position: absolute;
  }

  .modal-body {
    padding: 10px 20px;
    height: calc(100% - 100px);
    overflow-y: auto;
  }

  .modal-footer {
    background-color: #f6f7f8;
    overflow: hidden;
    border-top: 1px solid #d8d8d8;
    margin-bottom: 0;
    border-radius: 0 0 4px 4px;
    text-align: center;
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    transform: scale(0.8);
  }

  .modal_from_bottom {
    position: fixed;
    z-index: 1003;
    display: block;
    opacity: 1;
    bottom: 0px;
    left: 0;
    right: 0;
    background-color: white;
    padding: 0;
    top: auto;
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.3);
    margin: 0;
    width: 100%;
    height: 90%;
    border-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// Modal.vue?10f64e3c